import '../../../../assets/opel-font.css';
import '../../assets/third-party-css/index.css';
import { opelNewTheme } from '../../../common/styles/opelnew/opelnew-theme';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';
import '../../../common/styles/opelnew/opelnew-accordion.css';

const opelNewModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../components/input/text-input/general/contact-form-input-elements');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../vacs/common/common-vacs');
      await import('../../../finance-calculator/common/common-finance-calculator');
      await import('../../../finance-calculator/opelnew/opelnew-finance-calculator');
      return import('../../../vacs/opelnew/opelnew-vacs').then((vacs) => vacs.OpelNewVACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      await import('../../../vacs/opelnew/common/opelnew-wltp');
      return import('../../../offer-widget/opelnew/opelnew-offer-widget').then((ow) => ow.OpelNewOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'AfterSalesWidget',
    entryPoint: async () => {
      await import('../../../after-sales-widget/common/common-after-sales-widget');
      return import('../../../after-sales-widget/opelnew/opel-after-sales-widget').then(
        (afterSalesWidget) => afterSalesWidget.OpelNewAfterSalesWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/opelnew/opel-welcome-text-widget').then(
        (welcomeTextWidget) => welcomeTextWidget.OpelNewWelcomeTextWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'DealerIntroductionWidget',
    entryPoint: async () => {
      await import('../../../dealer-introduction-widget/common/common-dealer-introduction-widget');
      return import('../../../dealer-introduction-widget/opelnew/opel-dealer-introduction-widget').then(
        (welcomeTextWidget) => welcomeTextWidget.OpelNewDealerIntroductionWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/opelnew/opelnew-car-search-widget').then(
        (csw) => csw.OpelCarSearchWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LocationWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../location/opelnew/opelnew-common-location');
      return import('../../../location/opelnew/opelnew-location-widget').then((loc) => loc.OpelNewLocationWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Article',
    entryPoint: async () => {
      await import('../../../article/common/common-article');
      return import('../../../article/opelnew/opelnew-article').then((art) => art.ArticlePage);
    },
    labelPrefix: 'article',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/opelnew/opelnew-showroom').then((showroom) => showroom.OpelNewShowroomComponent);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/opelnew/v2/opelnew-showroom_v2').then(
        (showroom) => showroom.OpelNewShowroomV2Component
      );
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'LinkBoxWidget',
    entryPoint: async () => {
      await import('../../../linkbox/common/common-linkbox-widget');
      return import('../../../linkbox/opelnew/opelnew-linkbox-widget').then((linkbox) => linkbox.OpelNewLinkboxWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TeamsWidget',
    entryPoint: async () => {
      await import('../../../teams-widget/common/common-teams-widget');
      return import('../../../teams-widget/opelnew/opelnew-teams-widget').then((teams) => teams.OpelNewTeamsWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'DownloadsWidget',
    entryPoint: async () => {
      await import('../../../downloads-widget/common/common-downloads-widget');
      return import('../../../downloads-widget/opelnew/opelnew-downloads-widget').then(
        (teams) => teams.OpelNewDownloadsWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'GalleryWidget',
    entryPoint: async () => {
      await import('../../../gallery-widget/common/common-gallery-widget');
      return import('../../../gallery-widget/opelnew/opelnew-gallery-widget').then(
        (gallery) => gallery.OpelNewGalleryWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../../advisor/common/common-advisor');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../location/common/common-location');
      await import('../../../location/opelnew/opelnew-common-location');
      await import('../../components/input/text-input/general/contact-form-input-elements');
      await import('../../components/icon/opelnew/opelnew-chevron-down-icon');
      return import('../../../location/opelnew/opelnew-location').then((loc) => loc.LocationPage);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CommonForm',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../vacs/common/vehicle-list.service');
      return import('../../../common/form/opelnew/opelnew-form').then((loc) => loc.OpelNewForm);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      return import('../../../common-form-widget/opelnew/opelnew-common-form-widget').then(
        (form) => form.OpelNewCommonFormWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-widget').then(
        (spw) => spw.OpelNewStandardProWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-text-widget').then(
        (spw) => spw.OpelNewStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-image-and-text-widget').then(
        (spw) => spw.OpelNewStandardProWidgetImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-image-and-text-widget').then(
        (spw) => spw.OpelNewStandardProWidgetImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-downloads-widget').then(
        (spw) => spw.OpelNewStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-table-widget').then(
        (spw) => spw.OpelNewStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.OpelNewStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-video-widget').then(
        (spw) => spw.OpelNewStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-video-widget');
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-tabs-widget').then(
        (spw) => spw.OpelNewStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-banner-widget').then(
        (spw) => spw.OpelNewStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/opelnew/opelnew-standard-pro-gallery-widget').then(
        (spw) => spw.OpelNewStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/opelnew/opel-banner-widget').then((banner) => banner.OpelBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/opelnew/opelnew-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/opelnew/opelnew-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
]);

export default [opelNewModules, opelNewTheme] as BrandDescriptor;
